<template>
  <v-card elevation="3" color="#FFFFFF" class="text">
    <v-card-title class="text"
      >{{ question.literalNumber }} {{ question.question }}</v-card-title
    >
    <!-- question response-->
    <v-card-text>
      <div
        v-for="(option, o) in question.options.split(';')"
        :key="o"
        style="margin-left: 1%"
      >
        <v-tooltip :value="hover[o]" right transition="slide-x-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-row align="center">
              <v-hover v-model="hover[o]" v-if="checkHint(o)">
                <span style="margin-right: 10px; margin-left: 10px">
                  <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                </span>
              </v-hover>
              <v-checkbox
                :label="option"
                :value="option"
                style="word-break: normal"
                class="text"
                :disabled="disabled"
                @click="
                  registerAnswer(questionNumber, option), displayText(option, o)
                "
                v-model="selected"
              />
              <v-text-field
                label="respuesta"
                v-model="text[option]"
                v-show="showTxt(o, option)"
                style="margin-left: 10px"
                :disabled="disabled"
                v-on:keyup="
                  addOptionText(questionNumber, $event, question, option)
                "
              ></v-text-field>
            </v-row>
          </template>
          <span>{{ hints[o] }}</span>
        </v-tooltip>
      </div>

      <!-- <v-checkbox
        :disabled="disabled"
        label="otro"
        value="otro"
        @click="displayOther"
        >{{ "otro" }}</v-checkbox
      >
      <v-text-field
        label="otro"
        id="txtOther"
        v-model="otherTxt"
        :disabled="disabled"
        v-on:keyup="registerAnswer(questionNumber)"
        v-show="show"
      ></v-text-field> -->
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      check: false,
      selected: [],
      showText: [],
      otherTxt: "",
      hints: [],
      text: [],
      hover: [],
    };
  },
  props: {
    question: Object,
    questionNumber: String,
    answer: String,
    disabled: Boolean,
  },
  methods: {
    displayOther() {
      this.show = !this.show;
    },
    isTextOption(question, option) {
      return (
        question.type.toUpperCase().includes("TEXT") ||
        option.toUpperCase().includes("ESPECIFIQUE")
      );
    },
    registerAnswer(number, response) {
      if (this.text[response] != undefined) {
        this.text[response] = "";
      }
      this.$emit("selectAnswerMulti", { number: number, answer: response });
    },
    addEvidence({ number, file }) {
      this.$emit("addEvidence", { number: number, file: file });
    },
    addEvidenceDroped({ number, file }) {
      this.$emit("addEvidenceDroped", { number: number, file: file });
    },
    checkHint(option) {
      return this.hints[option] != "" && this.hints[option] != undefined;
    },
    addOptionText(number, answer, question, option) {
      this.$emit("addOptionText", {
        number: number,
        answer: answer,
        question: question,
        option: option,
      });
    },
    displayText(value, option) {
      if (this.showTxt(option, value)) {
        this.showText[option] = false;
        this.text[option] = "";
        this.text[value] = undefined;
        return;
      }

      if (value.toUpperCase() == "NO") {
        this.showText[option] = false;
        return;
      }
      if (
        value.toUpperCase().includes("ESPECIFIQUE") ||
        this.question.type == "multiText"
      ) {
        this.showText[option] = true;
      }
      if (value.toUpperCase().includes("AÑO")) {
        this.numeric = true;
      }
    },
    showTxt(o, option) {
      return this.showText[o] || this.text[option] != undefined;
    },
  },
  mounted() {
    if (this.question.hints != null) {
      this.hints = this.question.hints.split(";");
    }
    this.hints.forEach((hint, i) => {
      this.hover[i] = false;
    });
    if (this.answer != null) {
      this.selected = this.answer.split(";");
      this.selected.forEach((select, i) => {
        let temp = select;
        this.selected[i] = temp.split(":")[0];
        this.text[this.selected[i]] = temp.split(":")[1];
        if (
          temp.split(":")[1] == undefined &&
          this.selected[i] != "" &&
          this.question.type == "multiText"
        ) {
          this.text[this.selected[i]] = " ";
        }
      });
    }
  },
};
</script>
<style scoped>
.text {
  word-break: normal;
}
</style>
